import styled from "styled-components";
import Button from "../../../kanopy-ui/Button";

export const ButtonManageAccount = styled(Button)``;
export const MyAccountContainer = styled("div")`
   margin: 0 auto;
`;
